import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mat-merge",
  "use": "icon-soc-mat-merge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mat-merge\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"160\" y=\"288\" width=\"288\" height=\"448\" rx=\"32\" /><rect x=\"576\" y=\"288\" width=\"288\" height=\"448\" rx=\"32\" /><path d=\"M448 480h128v64H448z\" /><path d=\"M512 416l96 96-96 96v-64H416v-64h96v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mat-merge.svg
// module id = /BKb
// module chunks = 491